import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Nav } from "../components/site/Nav";
import { Footer } from "../components/site/Footer";
import { FloatingWhatsApp } from "../components/site/FloatingWhatsApp";
import { MenusContent } from "../components/site/MenusContent";

export default function Menus() {
  useEffect(() => {
    document.title = "Our Menus | Mediterranean Palate";
    window.scrollTo(0, 0);
    return () => { document.title = "Private Chef in Rutland & Stamford | Mediterranean Palate"; };
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="grain-overlay" />
      <Toaster theme="dark" position="bottom-right" />
      <Nav />
      <main data-testid="menus-page">
        <section className="tiled relative pt-28 md:pt-32 pb-10 md:pb-12 min-h-screen bg-[--bg-2]">
          <div className="max-w-[1600px] mx-auto px-5 md:px-10">
            <MenusContent />
          </div>
        </section>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </ReactLenis>
  );
}
